// Port of Ops src/components/ui/StatusPill.js with the English labels inlined
// (HQ has no i18n). An unmapped slug falls through to the value itself.

const LABELS = {
  active: 'Active',
  available: 'Available',
  blocked: 'Blocked',
  shared: 'Shared',
  transferred: 'Transferred',
  archived: 'Archived',
  pass: 'Pass',
  fail: 'Fail',
  issues: 'Issues',
  valid: 'Valid',
  expiring: 'Expiring',
  expired: 'Expired',
  minor: 'Minor',
  moderate: 'Moderate',
  major: 'Major',
  critical: 'Critical',
  emergency: 'Emergency',
  open: 'Open',
  'in-progress': 'In progress',
  closed: 'Closed',
  pending: 'Pending',
  resolved: 'Resolved',
  due: 'Due',
  overdue: 'Overdue',
  done: 'Done',
  draft: 'Draft',
  sealed: 'Sealed',
  approved: 'Approved',
  declined: 'Declined',
  scheduled: 'Scheduled',
};

const STYLES = {
  // Machine status
  active:       { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  available:    { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  blocked:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
  shared:       { bg: '#E6F1FB',                    color: '#185FA5' },
  transferred:  { bg: '#EEEDFE',                    color: '#534AB7' },
  archived:     { bg: 'var(--color-bg-tertiary)',   color: 'var(--color-text-tertiary)' },

  // Check results
  pass:         { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  fail:         { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
  issues:       { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },

  // Qualification status
  valid:        { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  expiring:     { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  expired:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },

  // Defect severity
  minor:        { bg: '#E6F1FB',                    color: '#185FA5' },
  moderate:     { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  major:        { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
  critical:     { bg: 'var(--color-danger)',        color: '#fff' },

  // Emergency
  emergency:    { bg: 'var(--color-danger)',        color: '#fff' },

  // General
  open:          { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
  // Not styled in Ops (falls to grey there); given a warning tone for the Faults tab.
  'in-progress': { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  closed:        { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  pending:       { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  resolved:      { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  due:           { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  overdue:       { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
  done:          { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  draft:         { bg: 'var(--color-bg-tertiary)',   color: 'var(--color-text-tertiary)' },
  sealed:        { bg: '#E6F1FB',                    color: '#185FA5' },
  approved:      { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  declined:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)' },
};

const SIZES = {
  sm: { fontSize: 9,  padding: '1px 6px' },
  md: { fontSize: 10, padding: '2px 8px' },
  lg: { fontSize: 11, padding: '3px 10px' },
};

export default function StatusPill({ status, label, size = 'md' }) {
  const key = typeof status === 'string' ? status.toLowerCase() : '';
  const s = STYLES[key] || { bg: 'var(--color-bg-tertiary)', color: 'var(--color-text-tertiary)' };
  const sz = SIZES[size] || SIZES.md;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      background: s.bg,
      color: s.color,
      borderRadius: 'var(--radius-full)',
      fontWeight: 'var(--font-weight-normal)',
      whiteSpace: 'nowrap',
      ...sz,
    }}>
      {label || LABELS[key] || status}
    </span>
  );
}
